export default __webpack_public_path__ + "static/media/WallNotification_WStore-Picture.362dc207.png";